import { Injectable } from '@angular/core';
import { ScopedTranslationService } from '@bbraun/shared/util-transloco-ng';
import { TranslocoService } from '@ngneat/transloco';
import { scope } from '../constants';

@Injectable({ providedIn: 'root' })
export class SecurityTranslationService extends ScopedTranslationService {
  constructor(translocoService: TranslocoService) {
    super(scope, translocoService);
  }
}
